module.exports = __webpack_public_path__ + "img/licensed.1522e9a9.svg";